module.exports = __webpack_public_path__ + "img/renew-contract-title.c8ca6350.svg";